import React from "react";
import { DndProvider } from "react-dnd-multi-backend";
import { HTML5toTouch } from "rdndmb-html5-to-touch";

// Treeview 1.x supplies a provider per tree. Keep their shared manager alive
// above Home's loading screen: otherwise a rapid tree unmount/remount can create
// a second MultiBackend before the previous tree finishes releasing its handlers.
export default function DashboardDragDropProvider({ children }) {
  return <DndProvider options={HTML5toTouch}>{children}</DndProvider>;
}
